const methods = [
    {
        txType: 'CreditcardDeposit',
        service: null,
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_none_creditcard.js')).fields,
    },
    {
        txType: 'NetellerDeposit',
        service: null,
        providerType: 'NETELLER',
        fields: async () => (await import('./neteller-deposit_none_neteller.js')).fields,
    },
    {
        txType: 'SkrillDeposit',
        service: null,
        providerType: 'SKRILL',
        fields: async () => (await import('./skrill-deposit_none_skrill.js')).fields,
    },
    {
        txType: 'MbankomatDeposit',
        service: null,
        providerType: 'MBANKOMAT',
        fields: async () => (await import('./mbankomat-deposit_none_mbankomat.js')).fields,
    },
    {
        txType: 'AstroPayDirectDeposit',
        service: null,
        providerType: 'ASTROPAYDIRECT',
        fields: async () => (await import('./astro-pay-direct-deposit_none_astropaydirect.js')).fields,
    },
    {
        txType: 'IdealDeposit',
        service: null,
        providerType: 'IDEAL',
        fields: async () => (await import('./ideal-deposit_none_ideal.js')).fields,
    },
    {
        txType: 'PProDeposit',
        service: 'GIROPAY',
        providerType: 'PPRO',
        fields: async () => (await import('./ppro-deposit_giropay_ppro.js')).fields,
    },
    {
        txType: 'BokuDeposit',
        service: null,
        providerType: 'BOKU',
        fields: async () => (await import('./boku-deposit_none_boku.js')).fields,
    },
    {
        txType: 'EnvoyDeposit',
        service: 'IDEAL',
        providerType: 'ENVOY',
        fields: async () => (await import('./envoy-deposit_ideal_envoy.js')).fields,
    },
    {
        txType: 'SiruDeposit',
        service: null,
        providerType: 'SIRU',
        fields: async () => (await import('./siru-deposit_none_siru.js')).fields,
    },
    {
        txType: 'PayPalDeposit',
        service: null,
        providerType: 'PAYPAL',
        fields: async () => (await import('./pay-pal-deposit_none_paypal.js')).fields,
    },
    {
        txType: 'PayboxDeposit',
        service: null,
        providerType: 'PAYBOX',
        fields: async () => (await import('./paybox-deposit_none_paybox.js')).fields,
    },
    {
        txType: 'LavaPayDeposit',
        service: null,
        providerType: 'LAVAPAY',
        fields: async () => (await import('./lava-pay-deposit_none_lavapay.js')).fields,
    },
    {
        txType: 'BlikDeposit',
        service: null,
        providerType: 'BLIK',
        fields: async () => (await import('./blik-deposit_none_blik.js')).fields,
    },
    {
        txType: 'EnvoyDeposit',
        service: 'SOFORT',
        providerType: 'ENVOY',
        fields: async () => (await import('./envoy-deposit_sofort_envoy.js')).fields,
    },
    {
        txType: 'ChinaUnionPayDeposit',
        service: null,
        providerType: 'CHINAUNIONPAY',
        fields: async () => (await import('./china-union-pay-deposit_none_chinaunionpay.js')).fields,
    },
    {
        txType: 'VenusPointDeposit',
        service: null,
        providerType: 'VENUSPOINT',
        fields: async () => (await import('./venus-point-deposit_none_venuspoint.js')).fields,
    },
    {
        txType: 'SweGiroDeposit',
        service: null,
        providerType: 'MOBILEGIRO',
        fields: async () => (await import('./swe-giro-deposit_none_mobilegiro.js')).fields,
    },
    {
        txType: 'ToditoCashDeposit',
        service: null,
        providerType: 'TODITOCASH',
        fields: async () => (await import('./todito-cash-deposit_none_toditocash.js')).fields,
    },
    {
        txType: 'TicketPremiumDeposit',
        service: null,
        providerType: 'TICKETPREMIUM',
        fields: async () => (await import('./ticket-premium-deposit_none_ticketpremium.js')).fields,
    },
    {
        txType: 'QiwiDeposit',
        service: null,
        providerType: 'QIWI',
        fields: async () => (await import('./qiwi-deposit_none_qiwi.js')).fields,
    },
    {
        txType: 'TolaMobileDeposit',
        service: null,
        providerType: 'TOLAMOBILE',
        fields: async () => (await import('./tola-mobile-deposit_none_tolamobile.js')).fields,
    },
    {
        txType: 'FlexepinDeposit',
        service: null,
        providerType: 'FLEXEPIN',
        fields: async () => (await import('./flexepin-deposit_none_flexepin.js')).fields,
    },
    {
        txType: 'CreditcardDeposit',
        service: 'PURPLEPAY',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_purplepay_creditcard.js')).fields,
    },
    {
        txType: 'CryptoCurrencyDeposit',
        service: null,
        providerType: 'CRYPTOCURRENCY',
        fields: async () => (await import('./crypto-currency-deposit_none_cryptocurrency.js')).fields,
    },
    {
        txType: 'Wallet88Deposit',
        service: null,
        providerType: 'WALLET88',
        fields: async () => (await import('./wallet88-deposit_none_wallet88.js')).fields,
    },
    {
        txType: 'MuchBetterDeposit',
        service: null,
        providerType: 'MUCHBETTER',
        fields: async () => (await import('./much-better-deposit_none_muchbetter.js')).fields,
    },
    {
        txType: 'SiirtoDeposit',
        service: null,
        providerType: 'SIIRTO',
        fields: async () => (await import('./siirto-deposit_none_siirto.js')).fields,
    },
    {
        txType: 'CreditcardDeposit',
        service: 'PAYR',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_payr_creditcard.js')).fields,
    },
    {
        txType: 'PaykasaDeposit',
        service: null,
        providerType: 'PAYKASA',
        fields: async () => (await import('./paykasa-deposit_none_paykasa.js')).fields,
    },
    {
        txType: 'JetonDeposit',
        service: null,
        providerType: 'JETON',
        fields: async () => (await import('./jeton-deposit_none_jeton.js')).fields,
    },
    {
        txType: 'CreditcardDeposit',
        service: 'ENTROPAY',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_entropay_creditcard.js')).fields,
    },
    {
        txType: 'BankDeposit',
        service: 'HELP2PAY',
        providerType: 'BANK',
        fields: async () => (await import('./bank-deposit_help2-pay_bank.js')).fields,
    },
    {
        txType: 'FunangaDeposit',
        service: 'CASHTOCODE',
        providerType: 'FUNANGA',
        fields: async () => (await import('./funanga-deposit_cashtocode_funanga.js')).fields,
    },
    {
        txType: 'EcoBanqDeposit',
        service: null,
        providerType: 'ECOBANQ',
        fields: async () => (await import('./eco-banq-deposit_none_ecobanq.js')).fields,
    },
    {
        txType: 'SwishDeposit',
        service: null,
        providerType: 'SWISH',
        fields: async () => (await import('./swish-deposit_none_swish.js')).fields,
    },
    {
        txType: 'BankIBANDeposit',
        service: null,
        providerType: 'BANKIBAN',
        fields: async () => (await import('./bank-ibandeposit_none_bankiban.js')).fields,
    },
    {
        txType: 'QliroDeposit',
        service: null,
        providerType: 'QLIRO',
        fields: async () => (await import('./qliro-deposit_none_qliro.js')).fields,
    },
    {
        txType: 'BankLocalDeposit',
        service: null,
        providerType: 'BANKLOCAL',
        fields: async () => (await import('./bank-local-deposit_none_banklocal.js')).fields,
    },
    {
        txType: 'EpsDeposit',
        service: null,
        providerType: 'EPS',
        fields: async () => (await import('./eps-deposit_none_eps.js')).fields,
    },
    {
        txType: 'BestPayDeposit',
        service: null,
        providerType: 'BESTPAY',
        fields: async () => (await import('./best-pay-deposit_none_bestpay.js')).fields,
    },
    {
        txType: 'RoyalPayVoucherDeposit',
        service: null,
        providerType: 'ROYALPAYVOUCHER',
        fields: async () => (await import('./royal-pay-voucher-deposit_none_royalpayvoucher.js')).fields,
    },
    {
        txType: 'SmsVoucherDeposit',
        service: null,
        providerType: 'SMSVOUCHER',
        fields: async () => (await import('./sms-voucher-deposit_none_smsvoucher.js')).fields,
    },
    {
        txType: 'MacroPayWalletDeposit',
        service: 'IDEAL',
        providerType: 'MACROPAY',
        fields: async () => (await import('./macro-pay-wallet-deposit_ideal_macropay.js')).fields,
    },
    {
        txType: 'MacroPayWalletDeposit',
        service: 'POLI',
        providerType: 'MACROPAY',
        fields: async () => (await import('./macro-pay-wallet-deposit_poli_macropay.js')).fields,
    },
    {
        txType: 'ToditoDeposit',
        service: null,
        providerType: 'TODITO',
        fields: async () => (await import('./todito-deposit_none_todito.js')).fields,
    },
    {
        txType: 'InovapayWalletDeposit',
        service: null,
        providerType: 'INOVAPAYWALLET',
        fields: async () => (await import('./inovapay-wallet-deposit_none_inovapaywallet.js')).fields,
    },
    {
        txType: 'InovapayVoucherDeposit',
        service: null,
        providerType: 'INOVAPAYVOUCHER',
        fields: async () => (await import('./inovapay-voucher-deposit_none_inovapayvoucher.js')).fields,
    },
    {
        txType: 'CryptoCurrencyDeposit',
        service: 'CRYPTOPAY',
        providerType: 'CRYPTOCURRENCY',
        fields: async () => (await import('./crypto-currency-deposit_cryptopay_cryptocurrency.js')).fields,
    },
    {
        txType: 'PremierPayDirectDeposit',
        service: 'DIRECTDEBIT',
        providerType: 'PREMIERPAYDIRECT',
        fields: async () => (await import('./premier-pay-direct-deposit_directdebit_premierpaydirect.js')).fields,
    },
    {
        txType: 'VCreditosWalletDeposit',
        service: null,
        providerType: 'VCREDITOS',
        fields: async () => (await import('./vcreditos-wallet-deposit_none_vcreditos.js')).fields,
    },
    {
        txType: 'PradexxDeposit',
        service: null,
        providerType: 'PRADEXX',
        fields: async () => (await import('./pradexx-deposit_none_pradexx.js')).fields,
    },
    {
        txType: 'DimocoDeposit',
        service: null,
        providerType: 'DIMOCO',
        fields: async () => (await import('./dimoco-deposit_none_dimoco.js')).fields,
    },
    {
        txType: 'AircashVoucherDeposit',
        service: null,
        providerType: 'AIRCASHVOUCHER',
        fields: async () => (await import('./aircash-voucher-deposit_none_aircashvoucher.js')).fields,
    },
    {
        txType: 'FonixDeposit',
        service: null,
        providerType: 'FONIX',
        fields: async () => (await import('./fonix-deposit_none_fonix.js')).fields,
    },
    {
        txType: 'ECommPayWalletDeposit',
        service: 'WEBMONEY',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-deposit_webmoney_ecommpay.js')).fields,
    },
    {
        txType: 'ECommPayWalletDeposit',
        service: 'QIWI',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-deposit_qiwi_ecommpay.js')).fields,
    },
    {
        txType: 'SecureTradingWalletDeposit',
        service: 'QIWI',
        providerType: 'SECURETRADINGWALLET',
        fields: async () => (await import('./secure-trading-wallet-deposit_qiwi_securetradingwallet.js')).fields,
    },
    {
        txType: 'InstadebitECheckDeposit',
        service: null,
        providerType: 'INSTADEBITECHECK',
        fields: async () => (await import('./instadebit-echeck-deposit_none_instadebitecheck.js')).fields,
    },
    {
        txType: 'PiastrixWalletDeposit',
        service: null,
        providerType: 'PIASTRIX',
        fields: async () => (await import('./piastrix-wallet-deposit_none_piastrix.js')).fields,
    },
    {
        txType: 'HowtopayWalletDeposit',
        service: 'POLI',
        providerType: 'HOWTOPAY',
        fields: async () => (await import('./howtopay-wallet-deposit_poli_howtopay.js')).fields,
    },
    {
        txType: 'HowtopayWalletDeposit',
        service: 'IDEAL',
        providerType: 'HOWTOPAY',
        fields: async () => (await import('./howtopay-wallet-deposit_ideal_howtopay.js')).fields,
    },
    {
        txType: 'CreditcardDeposit',
        service: 'PAYDTOVOUCHER',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_paydtovoucher_creditcard.js')).fields,
    },
    {
        txType: 'VippsDeposit',
        service: null,
        providerType: 'VIPPS',
        fields: async () => (await import('./vipps-deposit_none_vipps.js')).fields,
    },
    {
        txType: 'A1Deposit',
        service: null,
        providerType: 'A1',
        fields: async () => (await import('./a1-deposit_none_a1.js')).fields,
    },
    {
        txType: 'CreditcardDeposit',
        service: 'VEVOKREDIT',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-deposit_vevokredit_creditcard.js')).fields,
    },
    {
        txType: 'BankDeposit',
        service: 'PIX',
        providerType: 'BANK',
        fields: async () => (await import('./bank-deposit_pix_bank.js')).fields,
    },
    {
        txType: 'BoletoBancarioDeposit',
        service: null,
        providerType: 'BOLETO',
        fields: async () => (await import('./boleto-bancario-deposit_none_boleto.js')).fields,
    },
];

export { methods };
